"use client";

import { DialogDescription, DialogHeader } from "@/components/ui/dialog";
import { ModalProps } from "@/types";
import React from "react";
import * as S from "./styles";

const Modal: React.FC<ModalProps> = ({
  className,
  open,
  onOpenChange,
  children,
  titleModal,
  size = "default",
}) => {
  return (
    <S.Modal open={open} onOpenChange={onOpenChange}>
      <S.ModalContent $size={size}>
        <S.BoxContainer>
          <DialogHeader>
            <S.TitleModal>{titleModal}</S.TitleModal>
          </DialogHeader>
          <DialogDescription aria-describedby={undefined}></DialogDescription>
          {children}
        </S.BoxContainer>
      </S.ModalContent>
    </S.Modal>
  );
};

export default Modal;
